<sb-select
  [items]="items"
  [formControl]="selectControl"
  [searchable]="true"
  [multiSelect]="true"
  [showSelectAll]="true"
></sb-select>
